import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BehaviorSubject, Observable } from 'rxjs';
import { EnvironmentToken } from '../../../app.config';
import {
  Product,
  StoreProductPayload,
  UpdateProductPayload,
} from '../../models/catalog/product.model';

@Injectable({ providedIn: 'root' })
export class ProductService {
  #http = inject(HttpClient);
  #apiUrl = inject(EnvironmentToken).apiUrl;

  #items = new BehaviorSubject<Product[]>([]);
  public items$ = this.#items.asObservable();
  public items = toSignal(this.items$, { initialValue: [] });

  getAll() {
    this.#http
      .get<{ data: Product[] }>(`${this.#apiUrl}/api/admin/catalog/products`)
      .subscribe({
        next: (response) => this.#items.next(response.data ?? []),
        error: (e) => console.log(e),
      });
  }

  getById(id: number): Observable<{ data: Product }> {
    return this.#http.get<{ data: Product }>(
      `${this.#apiUrl}/api/admin/catalog/products/${id}`,
    );
  }

  create(payload: StoreProductPayload): Observable<{ data: Product }> {
    return this.#http.post<{ data: Product }>(
      `${this.#apiUrl}/api/admin/catalog/products`,
      payload,
    );
  }

  update(
    id: number,
    payload: UpdateProductPayload,
  ): Observable<{ data: Product }> {
    return this.#http.patch<{ data: Product }>(
      `${this.#apiUrl}/api/admin/catalog/products/${id}`,
      payload,
    );
  }

  delete(id: number): Observable<unknown> {
    return this.#http.delete(
      `${this.#apiUrl}/api/admin/catalog/products/${id}`,
    );
  }
}
